import { Toast as BaseToast } from "@base-ui/react/toast";
import type { ReactNode } from "react";

export type ToastVariant = "success" | "error" | "info";

export interface ToastData {
  variant: ToastVariant;
}

export interface ShowToastOptions {
  title: ReactNode;
  description?: ReactNode;
  timeout?: number;
}

export function useToast() {
  const manager = BaseToast.useToastManager<ToastData>();
  function show(variant: ToastVariant, options: ShowToastOptions) {
    return manager.add({
      title: options.title,
      description: options.description,
      timeout: options.timeout,
      data: { variant },
    });
  }
  return {
    success: (options: ShowToastOptions) => show("success", options),
    error: (options: ShowToastOptions) => show("error", options),
    info: (options: ShowToastOptions) => show("info", options),
  };
}
